namespace GeniuzPOS.PosShift {
    export interface PsVatRefundRateRow {
        Id?: number;
        VatRateNo?: number;
        PurchaseFrom?: number;
        PurchaseTo?: number;
        RoundedRefund?: number;
        RefundPc?: number;
        RefundFg?: VatRefundAmtFg;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PsVatRefundRateRow {
        export const idProperty = 'VatRateNo';
        export const nameProperty = 'PurchaseTo';
        export const localTextPrefix = 'PosShift.PsVatRefundRate';
        export const lookupKey = 'PsVatRefundRateRow';

        export function getLookup(): Q.Lookup<PsVatRefundRateRow> {
            return Q.getLookup<PsVatRefundRateRow>('PsVatRefundRateRow');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            VatRateNo = "VatRateNo",
            PurchaseFrom = "PurchaseFrom",
            PurchaseTo = "PurchaseTo",
            RoundedRefund = "RoundedRefund",
            RefundPc = "RefundPc",
            RefundFg = "RefundFg",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
